<template>
  <main class="mt-3">
    <div class="container">
      <a name="homeTop"></a>
      <h1>단일 검색기</h1>
      <table class="table table-sm table-hover">
        <thead>
          <tr>
           <td colspan="3">검색어 <input type="text" v-model="InputSearch" @keyup.enter="ButtonSearch()"> <button @click="ButtonSearch" class="btn btn-danger">검색</button></td>
          </tr>
          <tr>
            <td colspan="3">
              검색 타입
              <select v-model="SearchType">
                <option value="&q=">기본</option>
                <option value="&channelId=">채널ID</option>
              </select>
              목록 갯수 <input type="text" v-model="SearchCount" @keyup.enter="ButtonSearch()" style="width: 50px; text-align: right;"> 
              정렬 순서 
              <select v-model="order">
                <option value="date">최신순</option>
                <option value="rating">평점순</option>
                <option value="relevance">관련성</option>
                <option value="title">제목순</option>
                <option value="viewCount">조회순</option>
              </select>
            </td>
          </tr>
        </thead>
        <!-- 검색된 데이터 출력부 -->
        <tbody>
          <tr :key="i" v-for="(items,i) in youtubeItems">
            <td v-on:click="openUrl(items.id.videoId)"><img :src="items.snippet.thumbnails.high.url" width="300"></td>
            <td v-on:click="openUrl(items.id.videoId)">
              <table class="table" style="height:240px">
                <tbody>
                  <!--제목-->
                  <tr style="height:50%"><td>{{items.snippet.title}}</td></tr>
                  <!--영상설명-->
                  <tr><td>{{items.snippet.description}}</td></tr>
                </tbody>
              </table>
            </td>
            <td>
              <table class="table" style="height:240px">
                <tbody>
                  <!--체널이름-->
                  <tr style="height:50%"><td><a v-on:click="openChannelUrl(items.snippet.channelId)">{{items.snippet.channelTitle}}</a><br/><hr>{{items.snippet.channelId}}</td></tr>
                  <!--공개날짜-->
                  <tr><td>{{items.snippet.publishedAt}}</td></tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <a href="#homeTop"><button class="btn btn-danger" v-if="PrevPageToken != ''" @click="PrevPage">이전</button></a> &nbsp;&nbsp; {{ItemsCount}} &nbsp;&nbsp; <a href="#homeTop"><button class="btn btn-danger" v-if="NextPageToken != ''" @click="NextPage">다음</button></a>
    </div>
  </main>
</template>

<script>

export default {
  data() {
        return {
            SearchType:"&q=",
            InputSearch:"",
            SearchCount: 10,
            youtubeItems : [],
            ItemsCount : 1,
            NextPageToken : "",
            PrevPageToken : "",
            order:"date",
        }
    },
    methods : {
        async ButtonSearch() {
          console.log("검색버튼 클릭됨");

          // 검사
          if(this.SearchCount < 1 || this.SearchCount > 50) {
            alert("목록 갯수는 1~50개까지 허용됩니다.")
            this.SearchCount = 10;
            return
          }

          // 검색 개시
          console.log("검색어 : " + this.InputSearch);
          let url = "https://www.googleapis.com/youtube/v3/search?key=AIzaSyA955qRwL5-vOx4SkLzBMWSi4B09YwNh4Y&part=snippet&type=video&maxResults=" + this.SearchCount + "&videoDimension=2d&order=" + this.order + this.SearchType + this.InputSearch;
          console.log("url sessues : " + url);
          let jsonFile = null;
          try{
            jsonFile = await this.$api(encodeURI(url));
          } catch {
            alert("잘못된 id를 입력 하였습니다.\n기본 검색으로 채널id(채널이름 아래 표시)를 복사한후 검색을 실행해 주세요")
          }
          console.log("youtube search api sussesed : " + jsonFile)

          // 초기화
          this.NextPageToken = "";
          this.PrevPageToken = "";
          this.ItemsCount = 1;

          // 데이터 파싱
          this.youtubeItems = jsonFile.items;
          if(jsonFile.nextPageToken != undefined) {
            this.NextPageToken = jsonFile.nextPageToken;
          }
          if(jsonFile.prevPageToken != undefined) {
            this.PrevPageToken = jsonFile.prevPageToken;
          }
          console.log("next page token : " + this.NextPageToken)
          console.log("prev page token : " + this.PrevPageToken)
        },

        async NextPage() {
         console.log("다음 페이지 버튼 클릭됨");

          // 검색 개시
          console.log("검색어 : " + this.InputSearch);
          let url = "https://www.googleapis.com/youtube/v3/search?key=AIzaSyA955qRwL5-vOx4SkLzBMWSi4B09YwNh4Y&part=snippet&type=video&maxResults=" + this.SearchCount + "&videoDimension=2d&order=" + this.order + this.SearchType + this.InputSearch + "&pageToken=" + this.NextPageToken;
          console.log("url sessues : " + url);
          let jsonFile = await this.$api(encodeURI(url));
          console.log("youtube search api sussesed : " + jsonFile)

          // 초기화
          this.NextPageToken = "";
          this.PrevPageToken = "";

          // 데이터 파싱
          this.youtubeItems = jsonFile.items;
          if(jsonFile.nextPageToken != undefined) {
            this.NextPageToken = jsonFile.nextPageToken;
          }
          if(jsonFile.prevPageToken != undefined) {
            this.PrevPageToken = jsonFile.prevPageToken;
          }
          console.log("next page token : " + this.NextPageToken)
          console.log("prev page token : " + this.PrevPageToken)

          this.ItemsCount++
        },

        async PrevPage() {
         console.log("이전 페이지 버튼 클릭됨");

          // 검색 개시
          console.log("검색어 : " + this.InputSearch);
          let url = "https://www.googleapis.com/youtube/v3/search?key=AIzaSyA955qRwL5-vOx4SkLzBMWSi4B09YwNh4Y&part=snippet&type=video&maxResults=" + this.SearchCount + "&videoDimension=2d&order=" + this.order + this.SearchType + this.InputSearch + "&pageToken=" + this.PrevPageToken;
          console.log("url sessues : " + url);
          let jsonFile = await this.$api(encodeURI(url));
          console.log("youtube search api sussesed : " + jsonFile)

          // 초기화
          this.NextPageToken = "";
          this.PrevPageToken = "";

          // 데이터 파싱
          this.youtubeItems = jsonFile.items;
          if(jsonFile.nextPageToken != undefined) {
            this.NextPageToken = jsonFile.nextPageToken;
          }
          if(jsonFile.prevPageToken != undefined) {
            this.PrevPageToken = jsonFile.prevPageToken;
          }
          console.log("next page token : " + this.NextPageToken)
          console.log("prev page token : " + this.PrevPageToken)

          this.ItemsCount--
        },

        openUrl(id) {
          console.log("유튜브영상으로 이동 : " + id);
          window.open("https://www.youtube.com/watch?v=" + id,'','');
        },

        openChannelUrl(id) {
          console.log("유튜브채널로 이동 : " + id);
          window.open("https://www.youtube.com/channel/" + id,'','');
        },
    },
}
</script>
 